import React, { useState, useEffect /*useMemo*/ } from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import * as Bixby from '$/core';
import { Link, useMatch } from 'react-router-dom';
import CompanyDocumentsUpload from '$/components/company-documents-upload';
import './index.scss';
import { /*DocumentsAdminService,*/ DocumentsClientService } from '$/services';

interface IProps {
  currentCompany?: Bixby.Models.AdminCompany;
}

const AdminCompanyDocumentHostingUpload: React.FC<IProps> = props => {
  const { currentCompany } = props;
  //const [documents, setDocuments] = useState<Bixby.Models.CompanyDocument[]>();
  const match = useMatch('/admin/company/:companyId/document-hosting/upload/:emailId');
  const [companyDocumentCategories, setCompanyDocumentCategories] = useState<Bixby.Models.CompanyDocumentCategory[]>();
  const [hasError, setHasError] = useState<boolean>(false);
  const [hasNoDocs, setHasNoDocs] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [companyDocumentUploadByEmail, setCompanyDocumentUploadByEmail] =
    useState<Bixby.Models.CompanyDocumentUploadEmailId>();

  useEffect(() => {
    const getCompanyDocumentCategories = async () => {
      try {
        const companyDocumentCategories: Bixby.Models.CompanyDocumentCategory[] =
          await DocumentsClientService.getDocumentCategories();
        setCompanyDocumentCategories(companyDocumentCategories);
      } catch (err: any) {
        setHasError(true);
      }
    };

    getCompanyDocumentCategories();
  }, []);

  useEffect(() => {
    const getCompanyDocumentUploadByEmailId = async (companyId, emailId) => {
      try {
        setIsLoading(true);
        const data: Bixby.Models.CompanyDocumentUploadEmailId =
          await DocumentsClientService.getCompanyDocumentUploadByEmailId(companyId, emailId);
        if (Bixby.Utils.isNullOrEmpty(data)) setHasNoDocs(true);
        setCompanyDocumentUploadByEmail(data);
      } catch (err: any) {
        setHasError(true);
      } finally {
        setIsLoading(false);
      }
    };

    const emailIdFromUrl = match?.params.emailId;
    if (emailIdFromUrl && currentCompany) {
      getCompanyDocumentUploadByEmailId(currentCompany.id, emailIdFromUrl);
    }
  }, [match, currentCompany]);

  // to be uncommented post inital doc upload phase
  // useEffect(() => {
  //   const getDocuments = async () => {
  //     if (!currentCompany) return;
  //     try {
  //       const documents: Bixby.Models.CompanyDocument[] = await DocumentsAdminService.getDocumentsByCompanyId(
  //         currentCompany.id
  //       );
  //       setDocuments(documents);
  //     } catch (err: any) {
  //       setHasError(true);
  //     }
  //   };
  //   getDocuments();
  // }, [currentCompany]);

  // const hasDocumentsWithTags = useMemo<boolean | undefined>(() => {
  //   if (!documents) return undefined;
  //   const docsWithTags = documents.filter(
  //     _ => _.companyDocumentCompanyDocumentCategories !== null && _.companyDocumentCompanyDocumentCategories.length > 0
  //   );
  //   return docsWithTags && docsWithTags.length > 1;
  // }, [documents]);

  return (
    <>
      <section className="admin-profile-section bottom">
        {hasError && <p className="error">Unable to load data in order to upload company documents.</p>}
        {hasNoDocs && <p className="error">Documents are not found in storage.</p>}
        {!hasError && !hasNoDocs && (
          <>
            <h3>Bixby Document Hosting Upload</h3>
            {currentCompany && (
              <Link className="link" to={`/admin/company/${currentCompany.id}/document-hosting`}>
                Back to Documents List
              </Link>
            )}
            <CompanyDocumentsUpload
              companyDocumentUploadByEmail={companyDocumentUploadByEmail}
              companyDocumentCategories={companyDocumentCategories || []}
              // hasTags={hasDocumentsWithTags}
              isLoading={isLoading}
            />
          </>
        )}
      </section>
    </>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    currentCompany: state.companyState.currentCompany,
  };
};

export default connect(mapStateToProps)(AdminCompanyDocumentHostingUpload);
